function resolvePanel(step) {
  const link = step?.link || "";
  const label = step?.label || "";
  const [path, query = ""] = link.split("?");

  if (path === "settings/branding" && /(^|&)domain(&|$)/.test(query)) return "domain";
  if (path === "settings/branding" && /(^|&)menu(&|$)/.test(query)) return "menu";
  if (path === "settings/branding") return "theme";
  if (path === "saas") return "premium";
  if (path === "leads") return "leads";

  if (/email|lead\s*connector|leadconnector/i.test(label)) return "email";
  if (/domain/i.test(label)) return "domain";
  if (/premium|stripe|get paid/i.test(label)) return "premium";
  if (/populate/i.test(label)) return "leads";
  if (/menu builder/i.test(label)) return "menu";
  if (/theme|navigation|branding/i.test(label)) return "theme";

  return "confirm";
}

export default resolvePanel;
